import React from 'react';
import './Navbar.css';

const Navbar = ({ activeSection }) => {
  const navItems = [
    { id: 'overview', label: 'Overview' },
    { id: 'about', label: 'About' },
    { id: 'experience', label: 'Experience' },
    { id: 'skills', label: 'Skills' },
    { id: 'contact', label: 'Contact' },
  ];

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="navbar-tabs">
      {navItems.map((item) => (
        <button
          key={item.id}
          className={`nav-tab ${activeSection === item.id ? 'active' : ''}`}
          onClick={() => handleScroll(item.id)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
};

export default Navbar;
